export const prefix = 'tdesign-starter';
export const TOKEN_NAME = 'token'; //登录成功
